import React, { useState } from "react";
import {
  Breadcrumb,  
  PageHeader,
  ListingHeader,
  SweetAlert,
  ActionWrapper,
  TablePlus,
} from "../../../components";
import { Link, useNavigate } from "react-router-dom";
import {
  Columns,
  membershipService,
} from "../../../services/index.service";
import { modalNotification } from "../../../utils"; 

function ListMembership(props) {
  const navigate = useNavigate()

  const breadcrumb = [
    {
      path: "/admin/dashboard",
      name: "Dashboard",
    },
    {
      path: "#",
      name: "Membership Plan",
    },
  ];

  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const onConfirmAlert = () => {
    setIsAlertVisible(false);
    modalNotification({ type: "success", message: "Membership Deleted Successfully", })
    return true;
  };
  function onAction(e, handler){
    e.preventDefault();
    handler()
  }

  const statusActionOption = [
    {
      id: 1,
        name: 'Select Action'
      },
      {
        id: 2,
        name: 'Make Active'
      },
      {
        id: 3,
        name: 'Make Inactive'
      },
      {
        id: 4,
        name: 'Make Delete'
      }
  ]

  const actionFormatter = (options) => {
    return (
      <ActionWrapper>
        {options.map((item, key) => {
          return (
            <li onClick={(e)=>onAction(e, item.handler)} key={key} className="action_list">
              <Link to="#">
                <em className={item.icon} />
                {item.name}
              </Link>
            </li>
          );
        })}
      </ActionWrapper>
    );
  };

  const columns = Columns.membershipTableColumn({
    Action: () =>
      actionFormatter([
        {
          name: "Edit",
          icon: "icon ni ni-edit",
          handler: () =>{EditMembershipPage()},
        },
        {
          name: "Delete",
          icon: "icon ni ni-trash",
          handler:()=>{ setIsAlertVisible(true);
            document.body.click()}
        },
      ]),
  });

  const membershipData = membershipService();
  const EditMembershipPage = () =>{
    navigate('/admin/membership/edit')
  }
  const AddMembershipPage = () =>{
    navigate('/admin/membership/add');
  }
  return (
    <>
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <PageHeader heading="Membership Plan">
            <Breadcrumb breadcrumb={breadcrumb} />
          </PageHeader>
          <ListingHeader
            btnArray={[ "create", ""]}
            btnText="Add Membership Plan"            
            // popover={<CustomersFilterForm/>}
            onHandleShow={AddMembershipPage}
          />
        </div>
      </div>      
      <TablePlus
        hasLimit
        noOfPage="1"
        sizePerPage="10"
        page="1"
        count="100"
        tableData={membershipData}
        tableColumns={columns}
        showAction={false}
        isSearch={false}
        statusAction
        statusActionOption={statusActionOption}
        // tableLoader={isLoading}
        setSizePerPage=""
      />      
      <SweetAlert
        title="Are you sure"
        text=" you want to delete this Membership"
        show={isAlertVisible}
        icon="warning"
        showCancelButton
        confirmButtonText="Yes"
        cancelButtonText="No"
        setIsAlertVisible={setIsAlertVisible}
        onConfirmAlert={onConfirmAlert}
      />          
    </>
  );
}

export default ListMembership;
